import { clsx } from 'clsx';

export const ExpandCollapseIcon = ({ expanded = true }) => {
  return (
    <div className={'drop-shadow-[0_2px_2px_rgba(122,107,229,0.30)]'}>
      <svg
        className={clsx('transition-transform rotate-0', !expanded && 'rotate-180')}
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
      >
        <rect width="30" height="30" rx="15" fill="#F1F7F6" />
        <rect
          x="0.5"
          y="0.5"
          width="29"
          height="29"
          rx="14.5"
          stroke="#7A6BE5"
          strokeOpacity="0.3"
        />
        <path
          d="M9.60156 17.4495L14.7455 12.5506L19.3995 17.4495"
          stroke="#7A6BE5"
          strokeWidth="2"
        />
      </svg>
    </div>
  );
};
